import { processActionTypes } from '@Actions/production/processActions';

const ProcessReducers = (state = { }, action) => {
  switch (action.type) {
  case processActionTypes.GET_PROCESSES.LOADING: {
    const { getProcessesLoading } = action;
    return {
      ...state,
      getProcessesLoading,
    };
  }
  case processActionTypes.GET_PROCESSES.SUCCESS: {
    const { processes } = action;
    return {
      ...state,
      processes,
    };
  }
  case processActionTypes.GET_PROCESS_BY_ID.LOADING: {
    const { getProcessByIdLoading } = action;
    return {
      ...state,
      getProcessByIdLoading,
    };
  }
  case processActionTypes.GET_PROCESS_BY_ID.SUCCESS: {
    const { selectedProcess } = action;
    return {
      ...state,
      selectedProcess,
    };
  }
  case processActionTypes.CREATE_PROCESS.LOADING: {
    const { createProcessLoading } = action;
    return {
      ...state,
      createProcessLoading,
    };
  }
  case processActionTypes.UPDATE_PROCESS.LOADING: {
    const { updateProcessLoading } = action;
    return {
      ...state,
      updateProcessLoading,
    };
  }
  case processActionTypes.UPDATE_STATUS_PROCESS.LOADING: {
    const { updateProcessStatusLoading } = action;
    return {
      ...state,
      updateProcessStatusLoading,
    };
  }
  case processActionTypes.DELETE_PROCESS.LOADING: {
    const { deleteProcessLoading } = action;
    return {
      ...state,
      deleteProcessLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default ProcessReducers;
